import {AfterContentInit, Component, ContentChildren, Input, OnInit, QueryList} from '@angular/core';
import {CbjCardTabComponent} from './cbj-card-tab.component';
export class CbjCardTabsComponent implements OnInit, AfterContentInit {
   type: string;
   adlCardClasses: string;
   adlNavClasses: string;
   tabs: QueryList<CbjCardTabComponent>;
  navClasses: {};
  cardClasses: {};
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
    this.setClasses();
  }
/**
 * @return {?}
 */
ngAfterContentInit() {
    // get all active tabs
    const /** @type {?} */ activeTabs = this.tabs.filter((tab) => tab.active);

    // if there is no active tab set, activate the first
    if (activeTabs.length === 0) {
      this.selectTab(this.tabs.first);
    }
  }
/**
 * @param {?} tab
 * @return {?}
 */
selectTab(tab: CbjCardTabComponent) {
    // deactivate all tabs
    this.tabs.toArray().forEach(t => t.active = false);

    // activate the tab the user has clicked on.
    tab.active = true;
  }
/**
 * @return {?}
 */
private setClasses() {
    let /** @type {?} */ typeClass = {};
    if (this.type) {
      typeClass = {[this.type]: true};
    } else {
      typeClass = {tabs: true};
    }
    this.navClasses = {
      [this.adlNavClasses]: true,
      ...typeClass
    };
    this.cardClasses = {
      [this.adlCardClasses]: true
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cbj-card-tabs',
  template: `
    <div [ngClass]="cardClasses" class="card nav-card">
        <div class="card-header">
            <ul [ngClass]="navClasses" class="nav nav-tabs card-header-tabs">
                <li *ngFor="let tab of tabs" (click)="selectTab(tab)" class="nav-item" cbjRipple>
                    <span *ngIf="tab.icon" [class]="tab.icon + ' icon'"></span>
                    <span class="nav-link" [ngClass]="{'active': tab.active}">{{tab.title}}</span>
                    <span *ngIf="tab.active" class="indicator"></span>
                </li>
            </ul>
        </div>
        <div class="card-body">
            <ng-content></ng-content>
        </div>
    </div>
  `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'type': [{ type: Input, args: ['type', ] },],
'adlCardClasses': [{ type: Input, args: ['adlCardClasses', ] },],
'adlNavClasses': [{ type: Input, args: ['adlNavClasses', ] },],
'tabs': [{ type: ContentChildren, args: [CbjCardTabComponent, ] },],
};
}

function CbjCardTabsComponent_tsickle_Closure_declarations() {
/** @type {?} */
CbjCardTabsComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjCardTabsComponent.ctorParameters;
/** @type {?} */
CbjCardTabsComponent.propDecorators;
/** @type {?} */
CbjCardTabsComponent.prototype.type;
/** @type {?} */
CbjCardTabsComponent.prototype.adlCardClasses;
/** @type {?} */
CbjCardTabsComponent.prototype.adlNavClasses;
/** @type {?} */
CbjCardTabsComponent.prototype.tabs;
/** @type {?} */
CbjCardTabsComponent.prototype.navClasses;
/** @type {?} */
CbjCardTabsComponent.prototype.cardClasses;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
